import React from 'react';
type SectionTitleProps = {
  children: React.ReactNode;
  as?: 'h2' | 'h3';
  className?: string;
};
export function SectionTitle({
  children,
  as: Tag = 'h2',
  className = ''
}: SectionTitleProps) {
  return <Tag className={`font-display text-[26px] leading-snug font-bold uppercase text-gold text-center ${className}`} data-id="element-144" data-mp="3vxtn7uo1zk78">
      {children}
    </Tag>;
}